import { vShow as _vShow, withModifiers as _withModifiers, createElementVNode as _createElementVNode, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12fd4b9c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "info-panel" }
const _hoisted_2 = { class: "header_panel" }
const _hoisted_3 = { class: "header_faq" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Perguntas frequentes", -1))
const _hoisted_5 = {
  key: 0,
  class: "no-results-message"
}
const _hoisted_6 = ["onClick", "aria-expanded"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TUIViewer = _resolveComponent("TUIViewer")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_Transition, { name: "backdrop" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", {
          class: "backdrop",
          onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleInfo && _ctx.toggleInfo(...args)), ["stop"]))
        }, null, 512), [
          [_vShow, _ctx.isVisible]
        ])
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "slide-right" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("button", {
                class: "close-button",
                onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleInfo && _ctx.toggleInfo(...args)), ["stop"])),
                "aria-label": "Fechar painel"
              })
            ]),
            _withDirectives(_createElementVNode("input", {
              class: "input_panel",
              id: "title",
              title: "Título",
              placeholder: "Qual sua dúvida?",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchQuery) = $event)),
              required: ""
            }, null, 512), [
              [_vModelText, _ctx.searchQuery]
            ])
          ]),
          (_ctx.filteredInformations.length === 0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, " Nenhuma dúvida encontrada. "))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredInformations, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: _normalizeClass(['info-box', { 'info-box--active': _ctx.openItems[index] }])
            }, [
              _createElementVNode("button", {
                class: "header_dropdown",
                onClick: ($event: any) => (_ctx.toggleItem(index)),
                "aria-expanded": _ctx.openItems[index].toString()
              }, [
                _createElementVNode("p", null, _toDisplayString(item.question), 1),
                _createElementVNode("span", {
                  class: _normalizeClass([
                'icon__arrow',
                { 'icon__arrow--active': _ctx.openItems[index] }
              ]),
                  onClick: _withModifiers(($event: any) => (_ctx.toggleItem(index)), ["stop"])
                }, null, 10, _hoisted_7)
              ], 8, _hoisted_6),
              _createVNode(_Transition, { name: "slide-fade" }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("div", {
                    class: "content",
                    onClick: ($event: any) => (_ctx.toggleItem(index))
                  }, [
                    _createVNode(_component_TUIViewer, {
                      modelValue: item.response
                    }, null, 8, ["modelValue"])
                  ], 8, _hoisted_8), [
                    [_vShow, _ctx.openItems[index]]
                  ])
                ]),
                _: 2
              }, 1024)
            ], 2))
          }), 128))
        ], 512), [
          [_vShow, _ctx.isVisible]
        ])
      ]),
      _: 1
    })
  ]))
}